import { styled } from 'libs/ui/styled';

export const FieldsStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 24,

  '.orderSection-emptySpace': {
    flex: 1,
  },
  [theme.breakpoints.down('tablet')]: {
    flexDirection: 'column',
    gap: 16,

    '.orderSection-emptySpace': {
      display: 'none',
    },
  },
}));
